import React from "react";

import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Box from "@material-ui/core/Box";
import MenuItem from "@material-ui/core/MenuItem";

import CloseIcon from "@material-ui/icons/CloseRounded";
import HomeIcon from "@material-ui/icons/HomeRounded";
import NewPackIcon from "@material-ui/icons/CreateNewFolder";

import Packs from "../components/Packs";

const PacksMenu = ({ store }) => (
  <Box display="flex" flexDirection="column" className="packs_layout_root">
    <Grid
      container
      direction="row"
      justify="space-between"
      alignItems="center"
      className="nav_bar"
    >
      <IconButton className="back_button" onClick={store.goToHomePage}>
        <HomeIcon className="back_button_icon" />
      </IconButton>

      <IconButton className="close_button" onClick={store.handleMenuClose}>
        <CloseIcon className="close_button_icon" />
      </IconButton>
    </Grid>
    <Box flexGrow={1}>
      <Packs
        packs={store.packs}
        currentPackId={store.currentPackId}
        onClick={store.handlePackItemClick}
      />
    </Box>
    <MenuItem
      className="packs_list_item new_pack_item"
      onClick={() => store.createPack()}
    >
      <NewPackIcon className="menu_item_icon" />
      New Pack
    </MenuItem>
  </Box>
);

export default PacksMenu;
